var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"modal"}},[_c('div',{staticClass:"modal-mask fixed z-50 top-0 left-0 w-full h-screen table"},[_c('div',{staticClass:"table-cell align-middle"},[_c('div',{staticClass:"modal-container z-40 relative"},[_vm._t("body")],2)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }